import primitives from '../../../styles/primitives.module.css';

export const LoginForm = ({ formState, isSubmitting, onChange, onSubmit, t }) => (
  <form className={primitives.form} onSubmit={onSubmit}>
    <label className={primitives.field}>
      <span>{t('usernameLabel')}</span>
      <input
        name="username"
        type="text"
        autoComplete="username"
        value={formState.username}
        onChange={onChange}
        placeholder={t('usernamePlaceholder')}
        required
      />
    </label>
    <label className={primitives.field}>
      <span>{t('passwordLabel')}</span>
      <input
        name="password"
        type="password"
        autoComplete="current-password"
        value={formState.password}
        onChange={onChange}
        placeholder={t('passwordPlaceholder')}
        required
      />
    </label>
    <button className={primitives.primaryButton} type="submit" disabled={isSubmitting}>
      {isSubmitting ? t('signingIn') : t('signIn')}
    </button>
  </form>
);
